import React from "react";
import "../../../../css/Turismo/turismo.css";
import "../../../../css/Turismo/plazas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

const plazas = [
  {
    nombre: "Plaza San Martín",
    img: require("../../../img/Plazas/4-Plaza-San-Martin-2.jpg"),
    maps: "https://maps.app.goo.gl/myUaKNfHmurbnKCN9",
    calles: <>Belgrano – Pueyrredón – Colón – Rivadavia</>,
  },
  {
    nombre: "Plaza del Bicentenario de la Independencia",
    img: require("../../../img/Plazas/5-Plaza-Bicentenario.jpg"),
    maps: "https://maps.app.goo.gl/9XbjyZX3q2BrSLgH6",
    calles: (
      <>
        Bartolomé Mitre – San Lorenzo – <br />
        Sarmiento – Caseros
      </>
    ),
  },
  {
    nombre: "Plaza José Hernández",
    img: require("../../../img/Plazas/1-Plaza-Jose-Hernandez.jpg"),
    maps: "https://maps.app.goo.gl/uGs4Mk8wszdbSCM19",
    calles: (
      <>
        Bartolomé Mitre – Paula Albarracín –<br />
        Sarmiento – Juan Marengo
      </>
    ),
  },
  {
    nombre: "Plaza Presbítero Visca Caviglia",
    img: require("../../../img/Plazas/2-Plaza-Sagrado-Corazón-1.jpeg"),
    maps: "https://maps.app.goo.gl/gCK8CzyyJGJX9nDW8",
    calles: (
      <>
        Dr. R. Moyano – Cura Larocca –<br />
        Don Bosco – Maestro Bono
      </>
    ),
  },
  {
    nombre: "Plaza Manuel Belgrano",
    img: require("../../../img/Plazas/7-plaza-manuel-belgrano.jpg"),
    maps: "https://maps.app.goo.gl/gCK8CzyyJGJX9nDW8",
    calles: (
      <>
        Yrigoyen - Chiapero <br />
        - Chiarini - Bolivar
      </>
    ),
  },
  {
    nombre: "Plaza de los Intendentes",
    img: require("../../../img/Plazas/8-plaza-de-los-intendentes.jpg"),
    maps: "https://maps.app.goo.gl/gCK8CzyyJGJX9nDW8",
    calles: <>Paso & Laprida</>,
  },
];

const Plazas = () => (
  <div>
    <div
      className="plazas text-center"
      style={{
        backgroundImage: `url(${require("../../../img/Plazas/3-Plaza-San-Martin.jpg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "-160px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 350,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 1,
        }}
      />
    </div>
    <div className="container frm-plazas">
      <h6 className="titulo-plazas text-center">Plazas de nuestra ciudad</h6>
      <br />
      <div className="row">
        {plazas.map((plaza, idx) => (
          <div className="col-12" key={idx}>
            <div className="vista-plazas">
              <div className="row">
                <h4>{plaza.nombre}</h4>
                <section className="col-12 col-md-6">
                  <div className="imagen-plazas">
                    <img src={plaza.img} alt={plaza.nombre} />
                  </div>
                </section>
                <section className="col-12 col-md-6 align-self-center">
                  <a href={plaza.maps} target="_blank" rel="noopener noreferrer">
                    <div className="informacion-plaza text-center">
                      <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: 60, marginBottom: 20 }} />
                      <br />
                      <p>{plaza.calles}</p>
                    </div>
                  </a>
                </section>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Plazas;